//import "jquery-validation-unobtrusive";
import * as util from "./site";

declare global {
    interface Window {
        alternateTipLocation?: any[];
    }
}

//manually toggle/add/clear errors to UI (used only for data that lives solely in the UI)
export function toggleError(fieldName, errorMessage, isError) {
    if (isError == true) {
        addError(fieldName, errorMessage);
    } else {
        clearError(fieldName);
    }
}

export function addError(fieldName, errorMessage) {
    if ($(`#${fieldName}`).hasClass("valid")) {
        $(`#${fieldName}`).removeClass("valid").addClass("input-validation-error");
    }
    if ($(`label[for=${fieldName}]`).length)
        $("form").validate().showLabel($(`#${fieldName}`), errorMessage);
}

export function clearError(fieldName) {
    unHighlightField($(`#${fieldName}`));
}

export function highlightField(element) {
    if (element.hasClass("valid")) {
        element.removeClass("valid").addClass("input-validation-error");
    }
}

export function unHighlightField(element) {

    if (element.hasClass("input-validation-error")) {
        element.removeClass("input-validation-error").addClass("valid");
    }
    if (element.data("hasqtip"))
        element.qtip("destroy");
    else
        element.closest("span.k-widget").qtip("destroy");
}

export function showCustomError(inputElement, message, target) {
    target = target || $($(inputElement).prev("")); //previous input is the kendo generated one

    showQtip($(`<span>${message}</span>`), target);
}

export function clearFieldErrors(container) {
    $(container).find("[data-valmsg-replace]")
        .removeClass("field-validation-error")
        .addClass("field-validation-valid")
        .empty();
}

//override unobtrusive onError to hook in qTip - remove this to use normal MVC validation display
export function onError(error, inputElement) { // 'this' is the form element
    const container = $(this).find(`[data-valmsg-for='${inputElement[0].name}']`);
    const replace = (container.attr("data-valmsg-replace") ? $.parseJSON(container.attr("data-valmsg-replace")) : true) !== false;

    /**** Remove the following line so the default validation messages are not displayed ****/
    // container.removeClass("field-validation-valid").addClass("field-validation-error");

    error.data("unobtrusiveContainer", container);

    if (replace) {
        container.empty();
        error.removeClass("input-validation-error").appendTo(container);
    } else {
        error.hide();
    }

    // make sure we see errors for kendo dropdowns which have hidden inputs
    if (inputElement.is(":hidden")) {
        inputElement = inputElement.parent();
    }

    // if the input is still hidden, then ignore it, it might be purposefully hidden
    if (inputElement.is(":hidden")) {
        return;
    }

    /**** Added code to display the error message in a qTip tooltip ****/
    showQtip(error, inputElement);
}

export function parseDynamicContent(selector) {
    //use the normal unobstrusive.parse method
    $.validator.unobtrusive.parse(selector);

    //get the relevant form
    const form = $(selector).first().closest("form");

    //get the collections of unobstrusive validators, and jquery validators
    //and compare the two
    var unobtrusiveValidation = form.data("unobtrusiveValidation");
    var validator = form.validate();

    $.each(unobtrusiveValidation.options.rules,
        function (elname:string, elrules:any) {
            if (validator.settings.rules[elname] == undefined) {
                const args = {};
                $.extend(args, elrules);
                args["messages"] = unobtrusiveValidation.options.messages[elname];
                //edit:use quoted strings for the name selector
                $(`[name='${elname}']`).rules("add", args);
            } else {
                $.each(elrules,
                    function (rulename:string, data:any) {
                        if (validator.settings.rules[elname][rulename] == undefined) {
                            const args = {};
                            args[rulename] = data;
                            args["messages"] = unobtrusiveValidation.options.messages[elname][rulename];
                            //edit:use quoted strings for the name selector
                            $(`[name='${elname}']`).rules("add", args);
                        }
                    });
            }
        });

    const settings = $.data(form[0], "validator").settings;
    settings.errorPlacement = $.proxy(onError, form);
};

export function qTipValInit(alternateTipLocation?: any[]) {
    window.alternateTipLocation = alternateTipLocation || window.alternateTipLocation || new Array();
    if ($.grep($.validator.unobtrusive.adapters, function(o, i) { return o.name === "enforcetrue"; }).length === 0) {
        $.validator.addMethod("enforcetrue",
            function(value, element, param) {
                return (<HTMLInputElement>element).checked;
            });
        $.validator.unobtrusive.adapters.addBool("enforcetrue");
    }

    //$.validator.unobtrusive.parseDynamicContent = function(selector) {
    //    //use the normal unobstrusive.parse method
    //    $.validator.unobtrusive.parse(selector);

    //    //get the relevant form
    //    const form = $(selector).first().closest("form");

    //    //get the collections of unobstrusive validators, and jquery validators
    //    //and compare the two
    //    var unobtrusiveValidation = form.data("unobtrusiveValidation");
    //    var validator = form.validate();

    //    $.each(unobtrusiveValidation.options.rules,
    //        function(elname, elrules) {
    //            if (validator.settings.rules[elname] == undefined) {
    //                const args = {};
    //                $.extend(args, elrules);
    //                args.messages = unobtrusiveValidation.options.messages[elname];
    //                //edit:use quoted strings for the name selector
    //                $(`[name='${elname}']`).rules("add", args);
    //            } else {
    //                $.each(elrules,
    //                    function(rulename, data) {
    //                        if (validator.settings.rules[elname][rulename] == undefined) {
    //                            const args = {};
    //                            args[rulename] = data;
    //                            args.messages = unobtrusiveValidation.options.messages[elname][rulename];
    //                            //edit:use quoted strings for the name selector
    //                            $(`[name='${elname}']`).rules("add", args);
    //                        }
    //                    });
    //            }
    //        });

    //    const settings = $.data(form[0], "validator").settings;
    //    settings.errorPlacement = $.proxy(onError, form);
    //};

    $(document).ready(function() {
        const contentarea = $(".mainContent");
        if (contentarea.length === 0 || contentarea.is(":visible")) {
            showErrors();
        } else {
            contentarea.show(function() {
                util.hideOverlay(250, showErrors);
            });
        }
    });
}

export function showErrors() {
    var topErrorLoc = 0;

    $("span.k-widget.input-validation-error").removeClass("input-validation-error");

    $("form").each(function () { topErrorLoc = parseForm(this, topErrorLoc); });

    if (topErrorLoc !== 0) {
        topErrorLoc = topErrorLoc - ($(window).height() * .5);
        if (topErrorLoc < 0) topErrorLoc = 0;

        $("html, body").animate({
            scrollTop: topErrorLoc
        },
        2000);
    }
}

export function parseForm(form, topErrorLoc) {
    const $form = $(form);
    //hook into validation event, so we can customize the handlers
    const formvalidator = $.data(form, "validator");
    if (!formvalidator) return topErrorLoc; //we had to add this check due to changes in Microsoft.jQuery.Unobtrusive.Validation 3.2.0 - see http://stackoverflow.com/questions/24575443/jquery-validation-dataform0-validator-settings-returns-undefined
    const settings = formvalidator.settings;
    settings.errorPlacement = $.proxy(onError, $form);

    //apply qTip to server supplied errors
    // Run this function for all validation error messages
    $form.find(".field-validation-error").each(function() {
        // Get the name of the element the error message is intended for
        // Note: ASP.NET MVC replaces the '[', ']', and '.' characters with an
        // underscore but the data-valmsg-for value will have the original characters
        var inputElem = `#${$(this).attr("data-valmsg-for").replace(".", "_").replace("[", "_").replace("]", "_")}`;

        const corners = ["left center", "right center"];
        const flipIt = $(inputElem).parents("span.right").length > 0;

        // Hide the default validation error
        $(this).hide();

        var target = inputElem;
        if (window.alternateTipLocation.length > 0) {
            const fieldmap = jQuery.grep(window.alternateTipLocation,
                function (item, idx) {
                    var elemId = inputElem.substr(1);
                    if ($(inputElem).length > 0) elemId = $(inputElem)[0].id;
                    return (item.field === elemId);
                });
            if (fieldmap.length) target = $(fieldmap[0].target);
        }

        var errorContainer = $("." + inputElem.substr(1) + "-errortip");
        if (errorContainer.length > 0) target = errorContainer;

        const errorLoc = $(target).offset().top;
        if (topErrorLoc === 0 || errorLoc < topErrorLoc)
            topErrorLoc = errorLoc;

        var elem = $(inputElem);
        if (elem.data("role") === "numerictextbox" || elem.data("role") === "listbox" || elem.data("role") === "dropdownlist" || elem.data("role") === "multiselect")
            elem = elem.closest("span.k-widget,div.k-widget");

        if (elem.length === 0 || $(elem).is(":hidden")) elem = errorContainer;

        // Show the validation error using qTip
        elem.filter(":not(.valid)").qtip({
            content: { text: prettyErrorText($(this).text()) }, // Set the content to be the error message
            position: {
                my: corners[flipIt ? 1 : 0],
                at: corners[flipIt ? 0 : 1],
                viewport: true,//$(window),
                target: target[0]
            },
            show: { ready: true },
            hide: "",
            style: { classes: "qtip-red" }
        });
    });

    return topErrorLoc;
}

export function showQtip(error, inputElement) {
    // Set positioning based on the elements position in the form
    var elem = inputElement;

    //if (!elem.is(":visible"))
    //    elem = inputElement.siblings("input:visible");

    //if (!elem.is(":visible"))
    //    elem = inputElement.prevAll("input:visible");

    if (elem.data("role") === "numerictextbox" || elem.data("role") === "listbox" || elem.data("role") === "dropdownlist" || elem.data("role") === "multiselect")
        elem = elem.closest("span.k-widget,div.k-widget");

    const flipIt = elem.parents("span.right").length > 0;

    // Check we have a valid error message
    if (!error.is(":empty")) {
        let target = elem;
        if (window.alternateTipLocation.length > 0) {
            const fieldmap = $.grep(window.alternateTipLocation,
                function(item, idx) {
                    return (item.field == $(elem)[0].id);
                });
            if (fieldmap.length) target = $(fieldmap[0].target);
        }

        // Apply the tooltip only if it isn't valid
        const corners = ["left center", "right center"];
        elem.filter(":not(.valid)").qtip({
                overwrite: false,
                content: prettyErrorText(error.text()),
                position: {
                    my: corners[flipIt ? 1 : 0],
                    at: corners[flipIt ? 0 : 1],
                    viewport: true,//$(window),
                    target: target
                },
                show: {
                    event: false,
                    ready: true
                },
                hide: "",
                style: { classes: "qtip-red" }
                //events: {
                //    focus: function (event, api) {
                //        api.set('position.adjust.y', -10);
                //    },
                //    blur: function (event, api) {
                //        api.set('position.adjust.y', 0);
                //    }
                //}
            })
            // If we have a tooltip on this element already, just update its content
            .qtip("option", "content.text", prettyErrorText(error.text()))
            .qtip("option", "show.ready", true);
    }
    // If the error is empty, remove the qTip
    else {
        elem.qtip("destroy");
    }
}

export function prettyErrorText(origText) {
    return origText.replace(/The ([^]+) field is required./g, "$1 is required.")
        .replace(/The field ([^]+) must be a string or array type with a maximum length of '([^]+)'./g, "$1 must be less than $2 characters.");
}
